import Button from '~components/dumbs/Button';
import ArrowRight from '~components/svgs/ArrowRight';
import { Props } from './types';

function ButtonWithArrowRight(props: Props) {
  return <Button icon={<ArrowRight height="14px" />} {...props} />;
}

export default ButtonWithArrowRight;
